import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteUnitDialog, PropertyStructureComponent } from './property-structure.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { ContentCardModule } from 'src/app/shared/components/content-card/content-card.module';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CardDialogModule } from 'src/app/shared/components/card-dialog/card-dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddNodeComponent } from './add-node/add-node.component';
import { AreaTablesComponent, DelinkNodeDialog } from './area-tables/area-tables.component';
import { UnitLinkComponent } from './unit-link/unit-link.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DelinkAllocationComponent } from './delink-allocation/delink-allocation.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [
    PropertyStructureComponent,
    AddNodeComponent,
    AreaTablesComponent,
    UnitLinkComponent,
    DelinkNodeDialog,
    DelinkAllocationComponent,
    DeleteUnitDialog
  ],
  imports: [
    CommonModule,
    MatTreeModule,
    MatIconModule,
    FlexModule,
    FlexLayoutModule,
    MatDividerModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    ContentCardModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    CardDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDialogModule,
    MatPaginatorModule,
    MatDatepickerModule,
    DragDropModule,
  ],
  exports: [
    PropertyStructureComponent,
    AddNodeComponent,
    AreaTablesComponent,
    UnitLinkComponent,
    DelinkNodeDialog,
    DelinkAllocationComponent,
    DeleteUnitDialog
  ]
})
export class PropertyStructureModule { }
